import { createApp } from 'vue';
import Benchmark from '../benchmark/index.vue';
import "core-js/stable";
import VueApexCharts from "vue3-apexcharts";

const app = createApp({
    components: { Benchmark },
    template: '<Benchmark/>'
});

app.use(VueApexCharts);
app.component('apexchart', VueApexCharts);

document.addEventListener('DOMContentLoaded', () => {
    app.mount('#benchmark');
});
